// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1o2UC","large":"styles_large__3QVXG"};